const TestTitle = ({ title, subtitle, info, icon }: any) => {
  return (
    <div className="mb-3 lg:mb-8 flex items-start lg:items-center">
      {icon && <img src={icon} width={60} />}
      <div className={`flex flex-col ${icon ? "mr-5" : "mr-0"}`}>
        <h2 className="font-rokh font-[800] mt-1 lg:text-xl text-right">
          {title}
        </h2>
        <p className="font-rokh font-[700] text-right text-sm lg:text-base">
          {subtitle}
        </p>
        {info && <p className="text-sm lg:text-base">{info}</p>}
      </div>
    </div>
  );
};

export default TestTitle;
